var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#878B97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.1125L9.8875 3.5L7 6.3875L4.1125 3.5L3.5 4.1125L6.3875 7L3.5 9.8875L4.1125 10.5L7 7.6125L9.8875 10.5L10.5 9.8875L7.6125 7L10.5 4.1125Z",
    fill: "#878B97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularClose);
export default __webpack_public_path__ + "static/media/circularClose.08074a1451057360b8b6ac44b7ce53d1.svg";
export { ForwardRef as ReactComponent };